import { useQuery } from '@tanstack/react-query';
import * as Api from '../api';
import type { AnalyticsParams, OverviewResponse } from '../types';

interface IProps {
  orgId?: string;
  params: AnalyticsParams;
  enabled?: boolean;
}

const useOverview = ({ orgId, params, enabled = true }: IProps) =>
  useQuery<OverviewResponse>({
    queryKey: ['analytics', 'overview', orgId, params],
    queryFn: async () => {
      const { data } = await Api.GetOverview(params);
      return data;
    },
    enabled: !!orgId && enabled,
    staleTime: 30_000,
  });

export default useOverview;
